export default {
    site: {
        common: {
            hello: "Hello",
                thankYou: "Thank You",
                forMoreInfo: "for more info",
                hoverOverColumnHeaders: "Hover over the column headers for more information.",
                username: "username",
                score: "Score",
                points: "Points",
                pointsAbbreviation: "pts",
                chapter: "Chapter",
                tier: "Tier",
                t1: "T1",
                t2: "T2",
                t3: "T3",
                collectionsPerDay: "Collections Per Day",
                relicBoostPercent: "Relic Boost %",
                mountainHallPercentShort: "MTN. Hall %", // used in table heading keep it short.
                updated: "updated",
                lastUpdated: "Last Updated",
                created: "created",
                role: "role",
                Fellow: 'Fellow',
                Ambassador: 'Ambassador',
                Mage: 'Mage',
                Archmage: 'Archmage',
                saveChanges: "Save Changes",
                copy: "Copy",
                close: "Close",
                cancel: "Cancel",
                action: "Action",
                date: "Date",
                Left: "Left",
                Joined: "Joined",
                human: "Human",
                elf: "Elf",
                search: "Search",
                enter: "Enter",
                yes: "Yes",
                no: "No",
                tournament: "Tournament",
                tournaments: "Tournaments",
                fellowship: "Fellowship",
                player: "Player",
                member: "Member",
                history: "History",
                tournamentHistory:  "Tournament History",
                scoreHistory: "Score History",
                server: "Server",
                lastWeekGain: "Last Week Gain",
                comingSoon: "Coming Soon",
                chest: "chest",
                yourServer: "Your Server",
                allServers: "All Servers",
                boosts: "Boosts",
                marble: "marble",
                steel: "steel",
                planks: "planks",
                crystal: "crystal",
                scrolls: "scrolls",
                silk: "silk",
                elixir: "elixir",
                magic_dust: "magic dust",
                gems: "gems",
                sentient: "sentient",
                goods: "goods",
                average: "average",
                expansions: 'Expansions', // 5x5 grids
                cultureBoostMinimum: 'Culture Boost Min',
                cultureBoostCalculated: 'Culture Boost Calculated',
                neighborlyHelp: 'Neighborly Help',
                neighborlyHelpAbbreviation: 'NH'
        },
        // HIGH PRIORITY
        nav: {
            home: "Hem",
                players: "Spelare",
                fellowships: "Brödraskap",
                tournaments: "Turneringar",
                contact: "Kontakt",
                donate: "Donera",
                faq: "FAQ",
                news: "Nyheter",
                privacyPolicy: "Integritetspolicy",
                me: "Jag",
                myFellowship: "Mitt Brödraskap",

                // NOTE USED AT THE MOMENT
                globalStats: "Global statistik",
                articles: "Artiklar",
                fellowshipAdventure: "Brödraskapsäventyr",
                recruit: "Rekrytera",
        },
        // VERY HIGH PRIORITY!
        elvenArchitect: {
            viewCityOnElvenArchitect: "Visa stad på ElvenArchitect"
                ,obtainingLink: "Skapar länk"
                ,successMessage: "Klart! Klicka på länken nedan för att starta Elven Architect"
                ,ageOfLink: "Länken ovan visar staden som den var: "
                ,clickToGetCurrentCity: "<-- Klicka för att få aktuell stad",
        },
        // High Priority
        playerSelection: {
            headline: "View Site As",
                description: "This will update various parts of the site that are customized for the site user.  Examples include: my fellowship, my user, tournaments, and ranking pages.",
                youAreViewing: `You are now viewing the site as {username} on {serverName}.`,
                changeUser: "Change Player",
                enterYourUsernameToGetStarted: "Enter Your Elvenar Username To Get Started",
                thisIsNotASignup:"This is not a signup process.  By entering your username, we simply customize the site appropriately.  There are lots of Elvenar servers and we'll display ranking results for your server.  Also, your fellowship and personal user page links will become available."
        },
        searchBoxes: {
            enterFellowshipName: 'Enter Fellowship Name',
                instructions: "Type in the name and select one.",
                noFellowship: "No Fellowship",
        },
        relativeTime: {
            // Relative time strings - note: these aren't yet implemented in the code
            daysAgo: "days ago",
                minsAgo: "mins ago",
                hoursAgo: "hrs ago",
                justNow: "just now",
                never: "Never",
        },
        home: {
            welcome: "Welcome to Elven Stats!",
                youAreViewing: "You are now viewing the site as {username} on {serverName}",
                youCanChange: "You can change the user by clicking the avatar in upper right -or- by <router-link to='/contact'>visiting this page</router-link>",
                features: {
                headline: "Features",
                    fellowshipAdministration: {
                    headline: "Fellowship Administration <strong>MADE EASY</strong>",
                        bullet1: "Automatic tracking of boosted goods to help you better balance your fellowship",
                        bullet2: "Automatic tracking/generation of weekly report emails including points, tournament participation, monthly growth and motivating \"Accolades\" and personal best records",
                        bullet3: "Help identify your fellow members production imbalances such as supplies or incorrect ratio of tiers",
                },
                elvenArchitectIntegration: {
                    headline: "ElvenArchitect <strong>Integration</strong>",
                        description: "Load your city exactly as it is into ElvenArchitect in seconds! Use this to better plan your next big city reorganization or to find space you didn't realize you had! Look for the ElvenArchitect logo on the player pages."
                },
                advancedRankingLists: {
                    headline: "Advanced <strong>Ranking Lists</strong>",
                        bullet1: "Ranking List by Unlocked Areas (to compare yourself against people at same stage)",
                        bullet2: "View Boosts, Chapter Number, and more in Player lists.",
                },
                fellowshipTournamentTracking: {
                    headline: "Fellowship Tournament <strong>Tracking</strong>",
                        description: "See how your fellowship stacks up against others. Challenge other fellowships to a dual for a friendly competition!",
                },
                matchMaking: {
                    headline: "Match <strong>Making</strong>",
                        description: "ElvenStats tracks players boosts and the goods production ratios of fellowships.  With this information, fellowships can recruit the right candidates to balance their goods. Users looking for a fellowship can find fellowships that actually NEED their boosts. Saving time and reducing rejection!"
                }
            }
        },
        fellowship: {
            stats: {
                rank: "Rank",
                    points: "Points",
                    medianUserScore: "Median <strong>User Score</strong>",
                    memberCount: "Member <strong>Count</strong>",
            },
            barCharts: {
                clickSlice: "Click a slice for details (by member)",
                    tier1: "Tier 1",
                    tier2: "Tier 2",
                    tier3: "Tier 3",
                    drillDown: "Back To {0}"
            },
            idealCandidate: {
                heading: "Ideal Candidate",
                    description: "Would have a score around {medianScore} and would have one or more of the following boosts: {boosts}",
                    note: "Some combinations of boosts are not possible. See {0}"
            },
            memberGoodsTable: {
                heading: "Members Good Production",
                    description: `This table computes how much of each good your fellowship makes. We took an educated guess as to what your
                respective members boost percentages were and by default we're assuming each member does 3 collections per day
                (2x9h and 1x3h). To improve the accuracy, ask your fellowship members what their actual values are and enter them below. You can
                save what you enter so it will show up next time you load this page. The bar charts above will update automatically after you make changes. Hover over the column
                headers for more information about a particular column.'
                `,
                    refreshButtonText: 'Refresh Member List',
                    refreshButtonTip: 'This will add new members, remove old members, update fellowship roles, and update current scores.',
                    inactiveWarningTip: 'User may be inactive, Score Last Updated: {0}',
                    collectsPerDayValidation: "Must be between 1-6",
                    boostPercentValidation: "Must be between 40 - 700, do not include bonus from mountain halls",
                    perDayShort: "/day",

                    // HIGH PRIORITY - IMPORTANT TOOLTIPS
                    scoreTip: "The players score, please note this is not updated in realtime.  It's updated several times a week.",
                    chapterTip: "This is the chapter each player is in.  For reference: Elementals = 12, Halflings = 11, etc.",
                    boostTip: "The Players Boost and the amount PRODUCED per day.",
                    collectsPerDayTip: `***EDITABLE*** <br/>Collects Per Day. This is the number of times per day the user collects goods from their manufacturies. It should be a value from 1 - 6.  1 = 1x24h, 2=2x9h, 3=2x9h + 1x3h, 4=1x9h + 3x3h, 5=4x3h + 1x9h, 6=5x3h + 1x9h<BR/>Please see the FAQ for more.`,
                    relicBoostPercentTip: `***EDITABLE***<br/>The boost percent from relics, it's between 40-700.  It should not include the players Mountain Hall Percent.  That is detected automatically and added to this number`,
                    mountainHallPercentTip: "This is the Mountain Hall Boost Percentage we detected for this user.  It is used in conjunction with the boost %'s to calculate total boost percent.",
                    updatedTip: "This is the when the players city was last analyzed.  This process is what sets the boosts, elven architect data, calculates production from all manufactories, mountain hall %, and more. City map data is periodically fetched automatically but you can force an update below by clicking the refresh button.",

            },
            coinsAndSuppliesTable: {
                heading: "Coins / Supplies Production",
                    description: `The key column here is "Supplies Left" as it indicates whether a member will produce enough supplies to keep their
                manufactories producing 24/7.  Use the toggle switches below to take into account the players minimum culture boost (which is the boost you'd have if you had no neighborly help)
                and/or the number of times the member collects per day (as specified in Goods Table above).  Turning both off is useful if you want to see how much of the supplies are attributed
                to more manufactories or a higher culture boost. Finally, please note that having low negative (~10% of total) number of supplies left is fairly common. There are many ways players
                supplement their supplies such as by visiting neighbors, producing supplies at faster intervals (Beverages, Simple Tools, Bread...) or using Power of Provision spells.
                Think of the negative value as what you'd need to make up on a daily basis by doing one of these options.
                NOTE: at the moment troop production is not taken into account in the supplies used (Only Tier 1, Tier 2, and Tier 3 goods) so you may need more.`,

                    // These are the column text that show up under the icons. Keep them short.
                    minBoostPercent: "Min Boost %",
                    made: "Made",
                    used: "Used",
                    left: "Left",

                    // Low Priority TOOL TIPS
                    minimumCultureBoostPercent: "The culture boost percentage.  IMPORTANT: this is calculated assuming NO NEIGHBORLY HELP to culture buildings. In reality, this will likely be higher in your cities.",
                    moneyComputedTip: "The amount of coins produced in a day, includes any Ancient Wonders that produce coins",
                    moneyUsedComputedTip: "The amount of coins consumed by producing goods.",
                    moneyRemainingComputedTip: "Coins - Coins Used, it's the surplus or deficit in coins a player will have each day",
                    suppliesComputedTip: "The number of supplies that would be produced if all workshops were set to 24x1 (Toolboxes) + any ancient wonders. (does not include set bonuses)",
                    suppliesUsedComputedTip: "The number of supplies consumed by producing goods. DOES NOT include supplies used by your barracks! See explanation above.",
                    suppliesRemainingComputedTip: "Supplies - Supplies Used, it's the surplus or deficit in supplies a player will have each day",
                    manaTip: "The amount of Mana produced in 24 Hours (does not include Dragon Abbey)",
            },
            popCultureTable: {
                heading: "Population/Culture Details",
                    description: 'The table below shows population/culture for each member. Hover over the column headers for more information.',

                    // Icon Sub-Headings
                    minBoostPercent: "Min Boost %",
                    levels: "Levels",
                    total: "Total",
                    working: "Working",
                    available: "Available",
                    required: "Required",

                    // Low Priority - Tool Tips
                    wonderLevelsTip: "The total number of ancient wonder levels a player has.",
                    cultureBoostPercentTip: "The culture boost percentage.  IMPORTANT: this is calculated assuming NO NEIGHBORLY HELP to culture buildings. In reality, this will likely be higher in your cities.",
                    totalPopulationTip: "Total Culture produced by residences, culture/population hybrid buildings and ancient wonders",
                    workingPopulationTip: "Working Population - The amount consumed by buildings",
                    availablePopulationTip: "Available Population",
                    totalCultureTip: "Total Culture produced by culture buildings, culture/population hybrid buildings and ancient wonders",
                    requiredCultureTip: "Required Culture needed for all your buildings",
                    availableCultureTip: "Available Culture",
            },
            cityCoverageTable: {
                heading: "City Coverage",
                    description: "Shows how many tiles are used in each members city for the particular building type. The empty tiles are tiles which are currently not being used.",
                    tiles: 'Tiles'
            },

            // HIGH PRIORITY TO TRANSLATE
            weeklyReport: {
                heading: "Weekly Email Report",
                    description: "We automatically generate weekly reports suitable for sharing with your fellowship members. A new weekly report will be available each Sunday (approximately around 8pm UTC) for the previous week. Simply copy the blurb below and paste!",
                    selectReportHint: "Select Report for Week Ending On",
                    reportsAreOptimizedFor: "Email reports are optimized for display in the Elvenar messaging system such that columns align as properly as possible and usernames are truncated so it'll fit in a single message.",
                    accolades: "accolades",
                    tourneyChamp: " - Tourney Champ (this week): {0}",
                    tourneyHero: " - Tourney Hero (last 4 weeks): {0}",
                    highestGrowthPlusPercentage: " - Highest Growth (points & percentage): {0}",
                    highestGrowthPoints: " - Highest Growth (points): {0}",
                    highestGrowthPercentage: " - Highest Growth (percentage): {0}",
                    highestGrowthError: " - Highest Growth: Can't be determined yet, need more history",
                    newPersonalRecords: "New Personal Records",
                    userSetANewPersonalRecordFor: " * {0} set a new personal record for: {1}",
                    allMembersByPointGainThisWeek: "ALL MEMBERS by Point Gain / Percent (this week)",
                    tournamentPointsHeader: "TOURNAMENT Points (this week / TOTAL SINCE {0})",
                    top8ByPercentage: "TOP 8 By Percentage (this week)",
                    top8ByPointsSince: "TOP 8 By Points (Since {0})",
                    top8ByPercentageSince: "TOP 8 By Percentage (Since {0})",
                    reportGeneratedBy: "Report generated by elvenstats.com, for more see: ",
                    mostPointsInAWeek: "Most Points In A Week",
                    highestTournamentScore: "Highest Tournament Score",
                    highestTournamentRank: "Highest Tournament Rank",
                    insufficientHistoryForThesePlayers: "* Omitted: {0} due to insufficient history.  They will be included next week",
                    insufficientHistory1Week: "* Insufficient History for this section. Check back next week!",
                    insufficientHistory4Weeks: "* Insufficient History for this section. 4 weeks of history is needed. Check back soon!",
            },
            memberHistory: {
                heading: "Member History",
                    noChangesDetected: "No member changes detected yet since fellowship tracking began on {0}"
            },
            // Medium Priority
            notifications: {
                unsavedChanges: 'You have unsaved changes. When finished editing your fellowship click the save button.',
                    standbyImporting: 'Standby: We are importing some of your fellows that are missing information',
                    limitedHistory: "We very recently began tracking this {0} so there is limited history.  Each Sunday, weekly snapshots will show up here so be sure to check back soon!",
                    noChangesSinceTrackingBegan: "No Changes since tracking began",
            }
        },
        player: {
            fellowshipHistory: {
                heading: "Fellowship History"
            }
        },

    }
}


// WEBPACK FOOTER //
// ./src/lang/se.js